// Texto 29 (item 1, REGRAS 0.2): campo de texto que só entra em edição com o TOQUE.
// CAUSA de "segurar o item mostra o cursor e o menu do celular e o item nunca é pego": o campo de texto do celular é um
// componente do próprio sistema, que tem o seu toque longo (lupa, cursor, menu de copiar/colar e "Frases frequentes").
// Ao segurar em cima do texto, o sistema ficava com o dedo e cancelava o gesto do app; o item não levantava.
// Agora, fora de edição, o texto é só texto (do app): segurar é do app (mover ~1 s / selecionar ~3 s) e o toque curto
// abre o campo, com o cursor no lugar. Em edição, é o campo normal do celular (copiar/colar funcionam).
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Pressable, Text, TextInput, type StyleProp, type TextInputProps, type TextStyle, type ViewStyle } from 'react-native';
import { semArrastar, seNaoSegurou } from './Arrastar';
import { C } from './theme';

export type CampoToqueRef = { focus: () => void; blur: () => void; editando: () => boolean };
type Props = Omit<TextInputProps, 'style'> & {
  style?: StyleProp<TextStyle>;
  /** caixa em volta do texto quando NÃO está editando (ex.: o fundo cinza do Texto livre) */
  estiloCaixa?: StyleProp<ViewStyle>;
  /** abre já editando (ex.: subtítulo ou item recém-criado) */
  comecarEditando?: boolean;
  /** avisa quando entra/sai de edição (o bloco em edição não desliza nem é pego, REGRAS 3.2/3.5) */
  onEditando?: (on: boolean) => void;
  numberOfLinesFora?: number;
};

export const CampoToque = forwardRef<CampoToqueRef, Props>(function CampoToque(
  { style, estiloCaixa, comecarEditando, onEditando, numberOfLinesFora, value, placeholder, placeholderTextColor, onFocus, onBlur, ...resto }, ref) {
  const [editando, setEditandoSt] = useState(!!comecarEditando);
  const campo = useRef<TextInput | null>(null);
  const setEditando = (on: boolean) => { setEditandoSt(on); onEditando?.(on); };
  const aviso = useRef(onEditando); aviso.current = onEditando;
  const ed = useRef(editando); ed.current = editando;
  useEffect(() => { if (ed.current) aviso.current?.(true); return () => { if (ed.current) aviso.current?.(false); }; }, []);
  useImperativeHandle(ref, () => ({
    focus: () => { setEditando(true); setTimeout(() => campo.current?.focus(), 30); },
    blur: () => campo.current?.blur(),
    editando: () => editando,
  }), [editando]); // eslint-disable-line react-hooks/exhaustive-deps
  if (editando) return (
    // em edição, segurar é do campo (selecionar texto, copiar/colar): o item não é pego
    <TextInput ref={campo} {...semArrastar} {...resto} value={value} placeholder={placeholder} placeholderTextColor={placeholderTextColor ?? C.mute} autoFocus
      onFocus={e => { onFocus?.(e); }}
      onBlur={e => { setEditando(false); onBlur?.(e); }}
      style={[style, estiloCaixa as any]} />
  );
  const vazio = !String(value ?? '').length;
  return (
    <Pressable onPress={seNaoSegurou(() => setEditando(true))} accessibilityRole="button" accessibilityHint={placeholder}
      style={[{ justifyContent: 'center' }, estiloCaixa, (style as any)?.flex != null ? { flex: (style as any).flex } : null, { minWidth: 0 }]}>
      <Text style={[style, vazio ? { color: placeholderTextColor ?? C.mute } : null, { minWidth: 0 }]} numberOfLines={numberOfLinesFora}>
        {vazio ? placeholder : value}
      </Text>
    </Pressable>
  );
});
